import $x from '@/utils/$x';

/**
 *  首页内容配置  列表
 * @param {*} params
 * @returns
 */
export async function getAlbumList(params) {
  return $x.post('/album/list', params);
}

// 保存专辑
export async function saveAlbum(params) {
  return $x.post('/album/save', params);
}

// 删除专辑
export async function deleteAlbum(params) {
  return $x.post('/album/delete', params);
}

// 内容位的专题列表
export async function albumProjectList(params) {
  return $x.post('/album/mountList', params);
}

// 根据教练用户ID查询教练信息
export async function getTenantByCoachUserId(params) {
  return $x.post('/tenant/user/getTenantByCoachUserId  ', params);
}

// 挂载专题
export async function addProjectToAlbum(params) {
  return $x.post('/album/mount', params);
}

// 删除挂载专题
export async function deleteProjectToAlbum(params) {
  return $x.post('/album/unmount', params);
}
//  专题排序设置权重
export async function sortTopic(params) {
  return $x.post('/album/sort', params);
}
// 渠道列表
export async function getChannelList(params) {
  return $x.post('/contentChannel/getChannelCategoryRelPage', params);
}

// 查询一般专题列表
export async function getTopicList(params) {
  return $x.post('/topic/list', params);
}
